// extracted by mini-css-extract-plugin
export default {"aboutsClinicSection":"AboutsClinicSection_aboutsClinicSection__yh-2x","title":"AboutsClinicSection_title__KIT1B","description":"AboutsClinicSection_description__W3hS0"};